import * as constants from "./constants";
import Util from "./Util";

function getDefaultHeaders() {
  var token = localStorage.getItem("token");
  return {
    Authorization: "Bearer " + token,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
}

export function login(cidade, username, password, callBack) {
  var api = "https://api." + cidade + ".sgcontratos.com.br/";
  //var api = "http://api." + cidade + ".sgcontratos/"
  localStorage.setItem("api", api + "api/");
  var endpoint = "token/";
  var params = {
    username: username,
    password: password,
    client_id: constants.CLIENT_ID,
    client_secret: constants.CLIENT_SECRET,
    grant_type: "password",
  };
  var options = {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  fetch(api + "oauth/" + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.json();
      }
      return response.json();
    })
    .then((data) => {
      localStorage.setItem("token", data.access_token);
      callBack(undefined);
    })
    .catch(() => {
      callBack("Login ou senha inválidos");
    });
}

export function getContratados(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "contratados/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratados) => {
      callBack(contratados, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function existsContrato(
  numContrato,
  unidadeOrcamentaria,
  contratoId,
  callBack
) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(
    constants.getApi() +
      `existsContrato?num_contrato=${numContrato}&unidade_orcamentaria_id=${unidadeOrcamentaria}${
        contratoId ? `&contrato_id=${contratoId}` : ""
      }`,
    options
  )
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratados) => {
      callBack(contratados, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteContratado(id, callBack) {
  var endpoint = "contratados/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function searchContratos(searchText, page, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  var encodedSearchText = encodeURI(searchText);
  fetch(
    constants.getApi() +
      "contratosSearch/" +
      encodedSearchText +
      "?page=" +
      page,
    options
  )
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getContratos(page, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "contratos?page=" + page, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getAllContratos(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "contratosAll", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteContrato(id, callBack) {
  var endpoint = "contratos/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getFichaContrato(id, callBack) {
  var endpoint = "ficha/generate/";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getRelacaoContratos(callBack) {
  var endpoint = "relacaoContratos";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getRelacaoNotasFiscais(id, callBack) {
  var endpoint = `relacaoNotasFiscais/${id}`;

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getReciboDeAtestoDeServicos(parameters, callBack) {
  var endpoint = "reciboDeAtesto";
  var options = {
    method: "POST",
    body: JSON.stringify(parameters),
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.text() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      error.response.then((data) => {
        callBack(undefined, data);
      });
    });
}

export function deleteReciboDeAtestoDeServicos(id, callBack) {
  var endpoint = "recibos/" + id;
  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.text() };
        throw error;
      }
      return response.blob();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.response.then((data) => {
        callBack(data);
      });
    });
}

export function deleteTermoDeApostilamento(id, callBack) {
  var endpoint = "termosdeapostilamento/" + id;
  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.text() };
        throw error;
      }
      return response.blob();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.response.then((data) => {
        callBack(data);
      });
    });
}

export function getRelacaoContratados(callBack) {
  var endpoint = "relacaoContratados";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getRelacaoGestores(callBack) {
  var endpoint = "relacaoGestores";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getRelacaoFiscais(callBack) {
  var endpoint = "relacaoFiscais";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getRelacaoDistratos(callBack) {
  var endpoint = "relacaoDistratos";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getFiscais(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "fiscais/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((fiscais) => {
      callBack(fiscais, undefined);
    })
    .catch((error) => {
      console.log(error);
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteFiscal(id, callBack) {
  var endpoint = "fiscais/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function deleteDistrato(id, callBack) {
  var endpoint = "distratos/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response;
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      console.log(error);
      callBack({
        status: "500",
        message: "Ocorreram erros",
      });
    });
}

export function getGestores(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "gestorcontrato/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((gestores) => {
      callBack(gestores, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getDistratos(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "distratos/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((gestores) => {
      callBack(gestores, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteGestor(id, callBack) {
  var endpoint = "gestorcontrato/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getContratado(id, callBack) {
  var endpoint = "contratados/" + id;
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.json();
      }
      return response.json();
    })
    .then((data) => {
      callBack(data, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then(undefined, (errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getAdressWithCEP(cep, callBack) {
  fetch(constants.API_CORREIOS.split("data").join(cep))
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack({
        rua: responseData.logradouro,
        bairro: responseData.bairro,
        cidade: responseData.localidade,
        estado: responseData.uf,
      });
    })
    .catch(() => {
      callBack(undefined);
    });
}

export function createNewContratado(params, callBack) {
  var endpoint = "contratados";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateContratado(params, id, callBack) {
  var endpoint = "contratados/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getCreateFieldsContrato(callBack) {
  var endpoint = "contratos/create";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var contratados = Util.mapContratados(data.contratados);
      var unidades = Util.mapUnidades(data.unidades_orcamentarias);
      var tipos = Util.mapItens(data.tipos_contratos);
      var modalidades = Util.mapItens(data.modalidade_licitacao);
      var gestores = Util.mapGestores(data.gestores);
      var fiscais = Util.mapGestores(data.fiscais);
      var unidadesDeMedida = Util.mapMedidas(data.unidades_de_medidas);
      var fields = {
        contratados: contratados,
        unidades: unidades,
        tipos: tipos,
        modalidades: modalidades,
        gestores: gestores,
        fiscais: fiscais,
        unidadesDeMedida: unidadesDeMedida,
      };
      callBack(fields, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getEditFieldsContrato(id, callBack) {
  var endpoint = "contratos/" + id + "/edit";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var contratados = Util.mapContratados(data.contratados);
      var unidades = Util.mapUnidades(data.unidades_orcamentarias);
      var tipos = Util.mapItens(data.tipos_contratos);
      var modalidades = Util.mapItens(data.modalidade_licitacao);
      var gestores = Util.mapGestores(data.gestores);
      var fiscais = Util.mapGestores(data.fiscais);
      var unidadesDeMedida = Util.mapMedidas(data.unidades_de_medidas);
      var fields = {
        contratados: contratados,
        unidades: unidades,
        tipos: tipos,
        modalidades: modalidades,
        gestores: gestores,
        fiscais: fiscais,
        unidadesDeMedida: unidadesDeMedida,
        contrato: data.contrato,
      };
      callBack(fields, undefined);
    })
    .catch((error) => {
      console.log(error);
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function createNewContrato(params, callBack) {
  var endpoint = "contratos";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateContrato(params, id, callBack) {
  var endpoint = "contratos/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getEditFieldsFiscal(id, callBack) {
  var endpoint = "fiscais/" + id + "/edit";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var vinculos = Util.mapItens(data.vinculos);
      var unidades = Util.mapUnidades(data.unidades);
      var fiscal = data.fiscal;
      callBack(
        {
          vinculos: vinculos,
          unidades: unidades,
          fiscal: fiscal,
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getCreateFieldsFiscal(callBack) {
  var endpoint = "fiscais/create";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var vinculos = Util.mapItens(data.vinculos);
      var unidades = Util.mapUnidades(data.unidades);
      callBack({ vinculos: vinculos, unidades: unidades }, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function createNewFiscal(params, callBack) {
  var endpoint = "fiscais";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateFiscal(params, id, callBack) {
  var endpoint = "fiscais/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function createNewDistrato(params, callBack) {
  var endpoint = "distratos";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateDistrato(params, id, callBack) {
  var endpoint = "distratos/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getEditFieldsGestor(id, callBack) {
  var endpoint = "gestorcontrato/" + id + "/edit";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var vinculos = Util.mapItens(data.vinculos);
      var unidades = Util.mapUnidades(data.unidades).slice(1);
      var gestor = data.fiscal;
      callBack(
        {
          vinculos: vinculos,
          unidades: unidades,
          gestor: gestor,
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getCreateFieldsGestor(callBack) {
  var endpoint = "gestorcontrato/create";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var vinculos = Util.mapItens(data.vinculos);
      var unidades = Util.mapUnidades(data.unidades).slice(1);

      callBack({ vinculos: vinculos, unidades: unidades }, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getCreateFieldsDistrato(callBack) {
  var endpoint = "distratos/create";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var tipos = Util.mapItens(data.tipos);
      var contratos = Util.mapContratos(data.contratos).slice(1);
      var gestores = Util.mapGestores(data.gestores);
      callBack(
        { gestores: gestores, tipos: tipos, contratos: contratos },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getEditFieldsDistrato(id, callBack) {
  var endpoint = "distratos/" + id + "/edit";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      var tipos = Util.mapItens(data.tipos);
      var contratos = Util.mapContratos(data.contratos).slice(1);
      var gestores = Util.mapGestores(data.gestores);
      var distrato = data.distrato;
      callBack(
        {
          gestores: gestores,
          tipos: tipos,
          contratos: contratos,
          distrato: distrato,
        },
        undefined
      );
    })
    .catch((error) => {
      console.log(error);
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function createNewGestor(params, callBack) {
  var endpoint = "gestorcontrato";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateGestor(params, id, callBack) {
  var endpoint = "gestorcontrato/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getUnidadeOrcamentaria(id, callBack) {
  var endpoint = "unidades/" + id;
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      callBack(data, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function createNewUnidade(params, callBack) {
  var endpoint = "unidades";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateUnidade(params, id, callBack) {
  var endpoint = "unidades/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getUnidadesOrcametarias(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "unidades/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((unidades) => {
      callBack(unidades, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getRecibos(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "recibos/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((unidades) => {
      callBack(unidades, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getTermosDeApostilamento(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "termosdeapostilamento/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((unidades) => {
      callBack(unidades, undefined);
    })
    .catch((error) => {
      console.log(error);
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteUnidadeOrcamentaria(id, callBack) {
  var endpoint = "unidades/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getContrato(id, callBack) {
  var endpoint = "contratos/" + id;
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contrato) => {
      callBack(contrato, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function createNotas(params, callBack) {
  var endpoint = "notas";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getTiposRelatorios(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "tiporelatorios/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((tipos) => {
      callBack(tipos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getTiposDocumentos(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "tipodocumentos/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((tipos) => {
      callBack(tipos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getLogsReport(params, callBack) {
  var endpoint = "logsReport";
  var options = {
    method: "POST",
    headers: getDefaultHeaders(),
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData);
    })
    .catch(() => {
      callBack(undefined);
    });
}

export function getRecibosReport(params, callBack) {
  var endpoint = "recibosReport";
  var options = {
    method: "POST",
    headers: getDefaultHeaders(),
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData);
    })
    .catch(() => {
      callBack(undefined);
    });
}

export function getRelatorioEstatico(callBack) {
  var endpoint = "acompanhamentoFiscal";
  var options = {
    headers: getDefaultHeaders(),
  };

  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.blob();
    })
    .then((responseData) => {
        callBack(responseData);
    })
    .catch((error) => {
      console.log(error);
    });
}

export function getRelatorioWith(params, callBack) {
  var endpoint = "generateReport";
  var options = {
    method: "POST",
    headers: getDefaultHeaders(),
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(undefined, data);
      });
    });
}

export function getItensEdit(id, callBack) {
  var endpoint = "itens/" + id + "/edit";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      var unidades = Util.mapMedidas(responseData.unidades);
      var item = responseData.item;
      callBack({ unidades: unidades, item: item }, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteItemDeContrato(id, callBack) {
  var endpoint = "itens/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getItemDeContrato(id, callBack) {
  var endpoint = "itens/" + id;

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then(undefined, (errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function updateItemDeContratoWith(id, params, callBack) {
  var endpoint = "itens/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getAtasDeReuniao(callBack) {
  var endpoint = "atareuniao/";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function sendAtaReuniaoForm(params, callBack) {
  var endpoint = "atareuniao";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getAtaReuniao(id, callBack) {
  var endpoint = "atareuniao/imprimir/";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then(undefined, (errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getAtaReuniaoEdit(id, callBack) {
  var endpoint = "atareuniao/" + id + "/edit";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      var ata = responseData.ataReuniao;
      var fiscais = Util.mapFiscais(responseData.fiscais);
      callBack(
        {
          ata: ata,
          fiscais: fiscais,
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteAtaReuniao(id, callBack) {
  var endpoint = "atareuniao/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function updateAtaReuniaoForm(id, params, callBack) {
  var endpoint = "atareuniao/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getDiarioOcorrencias(callBack) {
  var endpoint = "diarioocorrencia/";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function printDiarioOcorrencias(id, callBack) {
  var endpoint = "diarioocorrencia/imprimir/" + id;
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function sendDiarioOcorrencia(params, callBack) {
  var endpoint = "diarioocorrencia";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getDiarioOcorrenciaEdit(id, callBack) {
  var endpoint = "diarioocorrencia/" + id + "/edit";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      var diario = responseData.diarioOcorrencias;
      var fiscais = Util.mapFiscais(responseData.fiscais);
      callBack(
        {
          diario: diario,
          fiscais: fiscais,
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteDiarioOcorrencia(id, callBack) {
  var endpoint = "diarioocorrencia/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function updateDiarioOcorrencia(id, params, callBack) {
  var endpoint = "diarioocorrencia/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getSolicitacoesEsclarecimentos(callBack) {
  var endpoint = "solicitacaoesclarecimento/";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function sendNewSolicitacoesEsclarecimentos(params, callBack) {
  var endpoint = "solicitacaoesclarecimento";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getSolicitacoesEdit(id, callBack) {
  var endpoint = "solicitacaoesclarecimento/" + id + "/edit";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      var solicitacao = responseData.solicitacao;
      var fiscais = Util.mapFiscais(responseData.fiscais);
      callBack(
        {
          solicitacao: solicitacao,
          itens: solicitacao.pendencias,
          fiscais: fiscais,
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deletePendencia(id, callBack) {
  var endpoint = "solicitacaoesclarecimento/pendencias/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function deleteSolicitacao(id, callBack) {
  var endpoint = "solicitacaoesclarecimento/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function updateSolicitacoesEsclarecimentos(id, params, callBack) {
  var endpoint = "solicitacaoesclarecimento/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function deletePreposto(id, callBack) {
  var endpoint = "prepostos/";
  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getPreposto(id, callBack) {
  var endpoint = "prepostos/" + id;
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function updatePreposto(id, params, callBack) {
  var endpoint = "prepostos/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getSolicitacoesPendenciasEdit(id, callBack) {
  var endpoint = "solicitacaoesclarecimento/pendencias/" + id + "/edit";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function updatePendencia(id, params, callBack) {
  var endpoint = "solicitacaoesclarecimento/pendencias/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function printSolicitacao(id, callBack) {
  var endpoint = "solicitacaoesclarecimento/imprimir/" + id;
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function printTermoCircunstanciado(id, callBack) {
  var endpoint = "termocircunstanciado/imprimir/" + id;

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getTermos(callBack) {
  var endpoint = "termocircunstanciado/";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteTermo(id, callBack) {
  var endpoint = "termocircunstanciado/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function sendNewTermoCircunstanciado(params, callBack) {
  var endpoint = "termocircunstanciado";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateTermo(id, params, callBack) {
  var endpoint = "termocircunstanciado/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getTermoEdit(id, callBack) {
  var endpoint = "termocircunstanciado/" + id + "/edit";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      var termo = responseData.termoCircunstanciado;
      var fiscais = Util.mapFiscais(responseData.fiscais);
      callBack(
        {
          termo: termo,
          comissao: termo.comissao,
          fiscais: fiscais,
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteComissaoItem(id, callBack) {
  var endpoint = "termocircunstanciado/comissao/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getComissaoItemEdit(id, callBack) {
  var endpoint = "termocircunstanciado/comissao/" + id + "/edit";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function updateComissaoItem(id, params, callBack) {
  var endpoint = "termocircunstanciado/comissao/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getProrrogacaoContratual(callBack) {
  var endpoint = "prorrogacaocontratual/";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteProrrogacaoContratual(id, callBack) {
  var endpoint = "prorrogacaocontratual/";
  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function updateProrrogacaoContratual(id, params, callBack) {
  var endpoint = "prorrogacaocontratual/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getProrrogacaoContratualEdit(id, callBack) {
  var endpoint = "prorrogacaocontratual/" + id + "/edit";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      var prorrogacaoContratual = responseData.prorrogacaoContratual;
      var fiscais = Util.mapFiscais(responseData.fiscais);
      callBack(
        {
          prorrogacaoContratual: prorrogacaoContratual,
          fiscais: fiscais,
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function sendNewProrrogacaoContratual(params, callBack) {
  var endpoint = "prorrogacaocontratual";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function printProrrogacaoContratual(id, callBack) {
  var endpoint = "prorrogacaocontratual/imprimir/" + id;
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.blob();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getStates(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.CITYS_API, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData);
    })
    .catch(() => {
      callBack(undefined);
    });
}

export function getDashboardData(callBack) {
  var endpoint = "dashdata/";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData);
    })
    .catch(() => {
      callBack(undefined);
    });
}

export function getNotasForContrato(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "notasList/" + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getNotaEdit(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "notas/" + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function updateNota(id, params, callBack) {
  var endpoint = "notas/";
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function deleteNota(id, callBack) {
  var endpoint = "notas/";

  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function deleteItemNota(id, callBack) {
  var endpoint = "notas/itens/";
  var options = {
    method: "DELETE",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getItemNotaEdit(id, callBack) {
  var endpoint = "notas/itens/" + id + "/edit";

  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function updateItemNota(id, params, callBack) {
  var endpoint = "notas/itens/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getContratosTrash(page, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "contratosTrash?page=" + page, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getContratadosTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "contratadosTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getUnidadesOrcamentariasTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "unidadesTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getGestoresTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "gestorcontratoTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getFiscaisTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "fiscaisTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getAtaReuniaoTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "atareuniaoTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getDiarioOcorrenciaTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "diarioocorrenciaTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getSolicitacoesTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "solicitacaoesclarecimentoTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getProrrogacaoContratualTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "prorrogacaocontratualTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getTermosCircunstanciadosTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "termocircunstanciadoTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getNotasTrash(contratoID, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "notasTrash/" + contratoID, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function restoreNota(id, callBack) {
  var endpoint = "notas/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.text();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreContratado(id, callBack) {
  var endpoint = "contratados/" + id + "/restore";
  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreContrato(id, callBack) {
  var endpoint = "contratos/" + id + "/restore";
  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreFiscal(id, callBack) {
  var endpoint = "fiscais/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreAtaReuniao(id, callBack) {
  var endpoint = "atareuniao/" + id + "/restore";
  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreDiarioOcorrencias(id, callBack) {
  var endpoint = "diarioocorrencia/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreProrrogacaoContratual(id, callBack) {
  var endpoint = "prorrogacaocontratual/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreSolicitacao(id, callBack) {
  var endpoint = "solicitacaoesclarecimento/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreTermo(id, callBack) {
  var endpoint = "termocircunstanciado/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreGestor(id, callBack) {
  var endpoint = "gestorcontrato/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreUnidadeOrcamentaria(id, callBack) {
  var endpoint = "unidades/" + id + "/restore";

  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getPersonalizacaoRelatorio(callBack) {
  var endpoint = "personalizarelatorio/";
  var options = {
    method: "GET",
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function sendPersonalizacaoRelatorio(params, callBack) {
  var endpoint = "personalizarelatorio/1";
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getUsuarios(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "usuarios/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getUsuariosEdit(id, callBack) {
  var endpoint = "usuarios/" + id + "/edit";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      callBack(
        {
          usuario: data.user,
          vinculos: Util.mapItens(data.vinculos),
          unidades: Util.mapUnidades(data.unidades).slice(1),
        },
        undefined
      );
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getUsuariosCreate(callBack) {
  var endpoint = "usuarios/create";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((data) => {
      callBack(data, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteUsuario(id, callBack) {
  var endpoint = "usuarios/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "DELETE",
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function createNewUsuarios(params, callBack) {
  var endpoint = "usuarios";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorCopy = error;
      errorCopy.then((data) => {
        callBack(data);
      });
    });
}

export function updateUsuarios(id, params, callBack) {
  var endpoint = "usuarios/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function restoreUsuario(id, callBack) {
  var endpoint = "usuarios/" + id + "/restore";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getUsuariosTrash(callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "usuariosTrash/", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getContratosDigitalizados(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "contratos/digitalizados/" + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteContratoDigitalizado(id, callBack) {
  var endpoint = "contratos/digitalizados/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "DELETE",
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function sendContratoDigitalizado(params, callBack) {
  var endpoint = "contratos/digitalizados";
  var token = localStorage.getItem("token");
  var options = {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getContratosDigitalizadosTrash(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "contratos/digitalizadosTrash/" + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function restoreContratoDigitalizado(id, callBack) {
  var endpoint = "contratos/digitalizados/" + id + "/restore";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getAditivos(id, page, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "aditivos/" + id + "?page=" + page, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getAditivoCreate(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "aditivos/" + id + "/create", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getAditivoEdit(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "aditivos/" + id + "/edit", options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getAditivosTrash(page, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "aditivosTrash?page=" + page, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((contratos) => {
      callBack(contratos, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function sendAditivo(params, callBack) {
  var endpoint = "aditivos";
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function updateAditivo(id, params, callBack) {
  var endpoint = "aditivos/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "PUT",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function sendImportacao(ano, codigoDoMunicipio, callBack) {
  var endpoint = "importFromTCE";
  var params = { ano: ano, codigo_municipio: codigoDoMunicipio };
  var options = {
    headers: getDefaultHeaders(),
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getMe(callBack) {
  var endpoint = "me";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then((responseData) => {
      localStorage.setItem("me", JSON.stringify(responseData));
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}

export function getCpfCnpj(callBack) {
  var endpoint = "cpfCnpj";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getNotasForContratado(
  ano,
  codigo_municipio,
  documento,
  callBack
) {
  var endpoint = "importContratadoFromTCE";
  var params = {
    ano: ano,
    codigo_municipio: codigo_municipio,
    cpf_cnpj: documento,
  };
  var options = {
    method: "POST",
    body: JSON.stringify(params),
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((responseData) => {
      callBack(responseData, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      return errorJson.then((errorData) => {
        var message = errorData[0];
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getValoresUnitariosByDate(date, contrato, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(
    constants.getApi() + "valoresunitarios/" + date + "/contrato/" + contrato,
    options
  )
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((itens) => {
      callBack(itens, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function getDistratosDigitalizados(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "distratos/digitalizados/" + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function deleteDistratoDigitalizado(id, callBack) {
  var endpoint = "distratos_digitalizados/" + id;
  var options = {
    headers: getDefaultHeaders(),
    method: "DELETE",
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function restoreDistratoDigitalizado(id, callBack) {
  var endpoint = "contratos/digitalizados/" + id + "/restore";
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack({
          status: status,
          message: message,
        });
      });
    });
}

export function getDistratosDigitalizadosTrash(id, callBack) {
  var options = {
    headers: getDefaultHeaders(),
  };
  fetch(constants.getApi() + "distratos/digitalizadosTrash/" + id, options)
    .then((response) => {
      if (!response.ok) {
        var error = { status: response.status, response: response.json() };
        throw error;
      }
      return response.json();
    })
    .then((usuarios) => {
      callBack(usuarios, undefined);
    })
    .catch((error) => {
      var errorJson = error.response;
      errorJson.then((errorData) => {
        var message = errorData.message;
        var status = error.status;
        callBack(undefined, {
          status: status,
          message: message,
        });
      });
    });
}

export function sendDistratoDigitalizado(params, callBack) {
  var endpoint = "distratos_digitalizados";
  var token = localStorage.getItem("token");
  var options = {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    method: "POST",
    body: JSON.stringify(params),
  };
  fetch(constants.getApi() + endpoint, options)
    .then((response) => {
      if (!response.ok) {
        throw response.text();
      }
      return response.json();
    })
    .then(() => {
      callBack(undefined);
    })
    .catch((error) => {
      error.then((data) => {
        callBack(data);
      });
    });
}



// WEBPACK FOOTER //
// ./src/ApiHelper.js